import React from 'react'
import Show from 'services/Show';
import { handleErrors, formatDate } from 'services/utils'
import { Spinner } from 'components/atoms';


export default class ShowExpertsRings extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      busy: false,
      show: {},
      showId: match.params.id,
      successSave: false,
      changed: false,
    }
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.withRings(this.state.showId).then(show => {
      if (this.mounted) {
        this.setState( { show, loading: false } );
      }
    }).catch((request) => {
      this.setState({loading: false});
      handleErrors(request);
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }




  saveChanges = (e) => {
    e.preventDefault();
    const show = this.state.show;
    show.experts_rings = show.experts_rings_map

    this.setState({ successSave: false, busy:true });
    show.save().then((item) => {
      if (!this.mounted) return; 
      this.setState({ 
        show: item, 
        successSave: true, 
        busy: false,
        changed: false, 
      });
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  updateRing = ({ target }) => {
    const value = target.value;
    const expertId = parseInt(target.name.replace(/\D+/g,''));
    if (expertId) {
      const show = this.state.show;
      show.experts_rings_map[expertId] = value;
      this.setState({ show, changed: true });
    }
  }

  render() {
    const {show, loading, changed, successSave} = this.state;
    let showInfo = null;
    
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    return (
      <div className="container-fluid">
        <h4>Эксперты и ринги выставки - {showInfo}</h4>
        {loading && <Spinner /> }

        { successSave && 
         <div className="row alert alert-success">
          Ринги экспертов выставки успешно обновлены.
         </div>}

        <ul>
          {(show.invited_experts || []).map(expert => (
            <li key={expert.id} className="row mb-2">
              <div className="col-2 row">
                <label className="col-3">Ринг</label>
                <div className="col-7">
                  <input type="number" min="0" max={show.invited_experts.count} className="form-control"  
                    name={'ring_for-' + expert.id} value={show.experts_rings_map[expert.id] || ''} 
                    onChange={this.updateRing} />
                </div>
              </div>
              <strong className="col-xl-3 col-lg-6">{expert.name}</strong>
            </li>)
          )}
        </ul>

        <div className="row">
          <div className="col-md-12 mb-3">
            <button type="button" onClick={this.saveChanges} disabled={!changed || this.state.busy} className="btn btn-primary me-2">
              { this.state.busy && <Spinner /> }
              Сохранить
            </button>
            <button type="button" onClick={this.onCancel} disabled={this.state.busy} className="btn btn-light">
              { this.state.busy && <Spinner /> }
              Назад
            </button>
          </div>
        </div>

      </div>
    );
  }
}

